import { render, staticRenderFns } from "./KiemSoatDienNuoc.vue?vue&type=template&id=a81ba650"
import script from "./KiemSoatDienNuoc.vue?vue&type=script&lang=js"
export * from "./KiemSoatDienNuoc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports